import { render, staticRenderFns } from "./ReportModule.vue?vue&type=template&id=145d6969"
import script from "./ReportModule.vue?vue&type=script&lang=js"
export * from "./ReportModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports